import { combineReducers } from 'redux'
import { reducer as formReducers } from 'redux-form'
import getAppointmentDataReducer from './getAppointmentDataReducer';
import dashboardTable from './dashboadTableReducer';
import dashboardGraph from './dashboardGraphReducer';
import externalPhyscianReducer from './externalPhyscianReducer';
import externalSourceFacilityReducer from './externalSourceFacilityReducer';
import internalPhysicianReducer from './internalPhysicianReducer';
import internalSourceFacilityReducer from './internalSourceFacilityReducer';
import patientRecordGraph from './patientRecordGraph';
import patientRecordReducer from './patientRecordReducer';
import createPatientReducer from './createPatientReducer';
import createAppointmentReducer from './createAppointmentReducer';
import patientDetailsReducer from './patientDetailsReducer';
import modalityReducer from './modalityReducer';
import scheduleDeviceReducer from './scheduleDeviceReducer';
import userProfileReducer from './userProfileReducer';
import filterAppointmentReducer from './filterAppointmentReducer';
import getPerFacilityReducer from './getPerFacilityReducer';
import getStudyDetailReducer from './getStudyDetailReducer';
import selectedFacilityReducer from './selectedFacilityReducer';
import getMedicalHistoryReducer from './getMedicalHistoryReducer';
import getReferralDetailsReducer from './getReferralDetailsReducer';
import getModalityOptionsReducer from './getModalityOptionsReducer';
import loadingReducer from './loadingReducer';
import procedureReducer from './procedureReducer';
import devicesOptionReducer from './devicesOptionReducer';
import getAllAppointmentReducer from './getAllAppointmentReducer';
import getContactInformationReducer from './getContactInformationReducer';



export const RESET_STATE = 'RESET_STATE';
export const appReducer = combineReducers({
  form: formReducers,
  dashboardGraph,
  dashboardTable,
  patientRecord: patientRecordReducer,
  singleAppointment: getAppointmentDataReducer,
  getAllAppointment: getAllAppointmentReducer,
  patientRecordGraph,
  internalPhysician: internalPhysicianReducer,
  externalPhyscian: externalPhyscianReducer,
  internalSourceFacility: internalSourceFacilityReducer,
  externalSourceFacility: externalSourceFacilityReducer,
  contactInformation: getContactInformationReducer,
  createPatient: createPatientReducer,
  createAppointment: createAppointmentReducer,
  patientDetails: patientDetailsReducer,
  modality : modalityReducer,
  scheduleDevice: scheduleDeviceReducer,
  userProfile: userProfileReducer,
  filterAppointment: filterAppointmentReducer,
  getPerFacility: getPerFacilityReducer,
  StudyDetail: getStudyDetailReducer,
  selectedFacility: selectedFacilityReducer,
  medicalHistoryRecord: getMedicalHistoryReducer,
  referralDetailsRecord: getReferralDetailsReducer,
  getModalityOptions: getModalityOptionsReducer,
  procedureOptions: procedureReducer,
  devicesOption: devicesOptionReducer,
  isLoading: loadingReducer
})


const rootReducers = ( state, action ) => {
  if ( action.type === RESET_STATE ) {
    state = undefined;
  }

  return appReducer(state, action)
}

export default rootReducers
